import React, { useState, useEffect } from "react";
import fetchData from "../services/requester";
import Logo from "../assets/images/logo.png";
import { Button, Input } from "antd";
import { Static } from "../components/static";

const Dashboard = () => {
  const [data, setData] = useState([]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const [apploading, setApploading] = useState(true);

  const getData = (value) => {
    setLoading(true);

    // Static File
    // let title = (Static && Static.length > 0 && Static[0]?.content) || "";
    // let content = (Static && Static.length > 0 && Static[1]?.content) || "";
    // setData(Static || []);
    // setTitle(title);
    // setContent(content);
    // setLoading(false);

    let reqURL = "chat?query=" + value;
    let reqOBJ = "";
    fetchData(
      reqURL,
      reqOBJ,
      (data) => {
        let title = (data && data.length > 0 && data[0]?.content) || "";
        let content = (data && data.length > 0 && data[1]?.content) || "";
        setData(data || []);
        setTitle(title);
        setContent(content);
        setLoading(false);
      },
      "GET"
    );
  };

  const parseRes = (res) => {
    let format = res?.replaceAll("*", "");
    return format;
  };

  const onSearch = (value) => {
    getData(value);
  };

  useEffect(() => {
    const iframe = document.createElement("iframe");
    iframe.src = "https://travel-agent-staging.onrender.com/docs";
    iframe.style.display = "none";
    iframe.onload = setApploading(false);
    document.body.appendChild(iframe);
  }, []);

  return (
    <div>
      <div className="container">
        <div>
          <div className="text-center pt-2 pb-2">
            <img style={{ height: "48px" }} src={Logo} alt="" />
          </div>

          <div className="print-hide" style={{ minHeight: "100px" }}></div>

          <div className="chat-input">
            <h2>Input Your Query Here</h2>
            <Input.Search
              size="large"
              enterButton
              onSearch={onSearch}
              loading={loading}
              placeholder="Dubai 3 Days"
            />
          </div>

          {apploading && (
            <div className="mt-5 text-center">
              <Button type="link" loading={true} style={{ cursor: "default" }}>
                Starting Application...
              </Button>
            </div>
          )}

          {data?.length > 0 && (
            <div className="chat-output">
              <div>
                <h2>
                  {title}
                  <Button
                    className="print-btn"
                    type="primary"
                    onClick={() => window.print()}
                  >
                    Print
                  </Button>
                </h2>
                <div className="chat-output-res">{parseRes(content)}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
